import React from "react";
import { StayTypesEnum } from "redmond";

export const getBenefitsTitle = (
  isVentureX: boolean,
): string => {
  if (isVentureX) {
    return "Explore our curated collections";
  }
  return "Explore the Lifestyle Collection";
}

export const getBenefitsSubtitle = (
  isVentureX: boolean,
  stayType?: StayTypesEnum,
  isMobile?: boolean
): string => {
  const isVacationRentals = stayType === StayTypesEnum.VacationRentals;

  if (isMobile) {
    if (isVentureX) {
      return "Get exclusive benefits when you book a collection stay, plus you can still earn 10X miles on hotels and 5X miles on vacation rentals.";
    }
    return "Get exclusive benefits when you book a collection stay, plus you can still earn 5X miles on hotels and vacation rentals.";
  }

  if (isVacationRentals) {
    return "Get exclusive benefits when you book a collection stay, plus you can still earn 5X miles on vacation rentals.";
  }

  if (isVentureX) {
    return "Get exclusive benefits when you book a collection stay, plus you can still earn 10X miles on hotels.";
  }

  return "Get exclusive benefits when you book a collection stay, plus you can still earn 5X miles on hotels.";
};

export const premierCollectionTitle = "Premier Collection";
export const lifestyleCollectionTitle = "Lifestyle Collection";

export const getCollectionSubtitle = (
  isPremier: boolean,
  isVacationRentals: boolean,
  isMobile?: boolean
): string => {
  if (isMobile) {
    return isPremier
      ? "World-class hotels, resorts and homes with luxury amenities."
      : "Stylish, comfortable hotels and homes in iconic locales.";
  }

  if (isPremier) {
    return isVacationRentals
      ? "World-class vacation rentals with luxury amenities."
      : "World-class hotels and resorts with luxury amenities.";
  }
  return isVacationRentals
    ? "Stylish, comfortable vacation rentals in iconic locales."
    : "Stylish, comfortable hotels in iconic locales.";
};

export const getPerksSubtitle = (isVentureX: boolean): JSX.Element => {
  if (isVentureX) {
    return (
      <>
        Both collections include these <strong>premium benefits</strong>, when
        available:
      </>
    );
  }
  return <>Enjoy these <strong>premium benefits</strong>, when available:</>;
};

export const roomUpgradePerk = "Room upgrade";
export const earlyCheckinPerk = "Early check-in & late checkout";
export const complimentaryFourthNightPerk = "Complimentary fourth night";

// Benefit text helper functions
export const getExperienceCreditText = (amount: number): string =>
  `Enjoy a $${amount}\nexperience credit`;

export const getEarnMilesHotelsText = (multiplier: number): string =>
  `Earn ${multiplier}X miles\non hotel bookings`;

export const getEarnMilesVRText = (multiplier: number): string =>
  `Earn ${multiplier}X miles\non vacation rentals`;

export const dailyBreakfastText = "Daily breakfast\nfor 2";

// Mobile-specific texts
export const collectionBenefitsTitle = "Collection benefits";
export const experienceCreditMobile = "$100 experience credit";
export const lifestyleExperienceCreditMobile = "$50 experience credit";
export const hotelRoomUpgradesMobile = "Hotel room upgrades when available";

// Cta texts
export const ctaSectionTitle = "Destinations for any travel style";
export const ctaSectionSubtitle = "Recline on a white sand beach, or hike in a sunlit valley. Discover your ideal destination in our selection of standout stays."
